import React, { useEffect, useRef } from "react";
import DataTable from "react-data-table-component";
import PageWrapper from "@components/layouts/PageWrapper";
import Search from "@components/layouts/Search";
import { useLocation, useNavigate } from "react-router-dom";
import { productPriceColumns } from "@helpers/columns/product/product-price.columns";
import { Toast } from "@helpers/popups/Toast";
import usePagination from "@hooks/usePagination";
import useSearch from "@hooks/useSearch";
import { getBaseUrl } from "@utils/general/getBaseUrl";
import { TSuccessResponse } from "@type-defs/general/TSuccessResponse";

import { useErrorHandling } from "@hooks/useErrorHandling";
import { TProduct } from "@type-defs/product/TProduct";
import { TDeleteSuccesResponse } from "@type-defs/general/TDeleteSuccessResponse";
import { DeletePopup } from "@helpers/popups/DeletePopup";
import {
  useDeleteProductMutation,
  useGetAllProductsQuery,
  useUpdateProductMutation
} from "@states/product/product.api";
import { PRODUCT_PRICE } from "@utils/constants/product-price.constants";
import { castTypeArr } from "@utils/general/cast-type";
import { TFailResponse } from "@type-defs/general/TFailResponse";
import NoRecord from "@components/layouts/NoRecord";
import TableSkeleton from "@components/layouts/TableSkeleton";
import { LoadingSpinner } from "@components/layouts/LoadingSpinner";
import ProductFilter from "@components/filters/ProductFilter";
import AuthComponent from "@components/auth/component";
import useGetPermission from "@hooks/common/useGetPermission";
import { LOCAL_STORAGE_KEYS } from "@utils/constants/local-storeage-keys.constants";

const ProductPricePage = () => {
  const { hasAccess } = useGetPermission();
  const { page, limit, handlePageChange, handlePerRowsChange } =
    usePagination();
  const { search, setSearch } = useSearch();
  const navigate = useNavigate();
  const location = useLocation();
  const filterRef = useRef({
    product_category_id: undefined,
  });
  const {
    data,
    isFetching,
    error: getAllError,
    refetch,
  } = useGetAllProductsQuery({
    page,
    limit,
    search: search,
    ...filterRef.current,
  });
  // const [deleteProduct, { error: deleteError, isLoading }] =
  //   useDeleteProductMutation();
const [
    updateProduct,
    { isLoading, error: updateError, isSuccess, originalArgs },
  ] = useUpdateProductMutation();
  useErrorHandling(...castTypeArr<TFailResponse>([getAllError, updateError]));

  useEffect(() => {
    if (location.state?.reload) {
      refetch();
    }
  }, [location.state?.reload]);

  const editHandler = (product: TProduct) => {
    navigate(`${PRODUCT_PRICE.BASE_PATH}${product.product_id}/edit`, {
      state: {
        product,
      },
    });
  };

  const deleteHandler = async (id: number | string) => {
    try {
      const { isConfirmed } = await DeletePopup.fire();

      if (isConfirmed) {
        // const res = await deleteProduct(id);

        // const successData = "data" in res ? res.data : null;
        // const { success, message } = successData as TDeleteSuccesResponse;

        // if (success) {
        //   Toast.fire({
        //     icon: "success",
        //     title: message,
        //   });

        //   refetch();
        // }

       
        const formData = new FormData();
        //@ts-ignore
          formData.append("primary_sales_tax_type", null);
        //@ts-ignore
          formData.append("primary_sales_price", 0);
        //@ts-ignore
          formData.append("primary_sales_tax", 0);
        //@ts-ignore
          formData.append("secondary_sales_tax_type", null);
        //@ts-ignore
          formData.append("secondary_sales_price", 0);
        //@ts-ignore
          formData.append("secondary_sales_tax", 0);

          //@ts-ignore
          formData.append("direct_sales_tax_type", null);
        //@ts-ignore
          formData.append("direct_sales_price", 0);
        //@ts-ignore
          formData.append("direct_sales_tax", 0);
       
        const response = await fetch(`${getBaseUrl()}product/price-update/${id}`, {
          method: "PATCH",
          body: formData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              LOCAL_STORAGE_KEYS.ACCESS_TOKEN_KEY
            )}`, // Add token here
          },
        });

        const res = await response.json();
        if (res.status === "fail") {
          Toast.fire({
            title: res.message,
            icon: "error",
          });
        }
        if (res.status === "error" && res.errorCode === 500  ) {
          Toast.fire({
            title: res.message,
            icon: "error",
          });

          return;
        }

        if (res?.errors?.length > 0) {
          for (const error of res.errors) {
            Toast.fire({
              title: error,
              icon: "error",
            });
          }

          return;
        }

        const { success, message } = res as TSuccessResponse;

        if (success || isSuccess) {
          Toast.fire({
            title: "Deleted Successfully",
            icon: "success",
          });

          refetch();

          // navigate(PRODUCT_PRICE.BASE_PATH, {
          //   state: {
          //     reload: true,
          //   },
          // });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <AuthComponent
      action="view"
      module="Product"
      subModule="Product Price"
      page
    >
      {isLoading && <LoadingSpinner />}
      <Search setSearch={setSearch} />
      <PageWrapper
        // addPath={`${PRODUCT.BASE_PATH}add`}
        // addButtonTitle="Add New Product Price"
        title="Product Price List"
        hasCreatePermission={hasAccess(
          "create",
          "Product",
          "Product Price"
        )}
      >
        <ProductFilter refetch={refetch} filterRef={filterRef} />
        <DataTable
          keyField="product_id"
          responsive
          // onRowClicked={(row) => {
          //   editHandler(row);
          // }}
          striped
          pointerOnHover
          highlightOnHover
          pagination
          paginationServer
          //@ts-ignore
          paginationTotalRows={data?.paginator?.totalItems}
          progressPending={isFetching}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          noDataComponent={<NoRecord />}
          progressComponent={<TableSkeleton row={10} col={10} />}
          //@ts-ignore
          columns={productPriceColumns(editHandler, deleteHandler)}
          //@ts-ignore
          data={data?.data}
        />
      </PageWrapper>
    </AuthComponent>
  );
};

export default ProductPricePage;
